import type {
  CurrentUser,
  PermissionAdminLevel,
  PermissionLevel,
} from '@/api/User/types.ts'
import type { LayoutType } from '@/api/types.ts'

export type AdminPermissionType = 'user' | 'business' | 'initiative'

export interface AuthUser extends CurrentUser {
  hasAdminPermission: (
    type: AdminPermissionType,
    level: PermissionAdminLevel
  ) => boolean
  hasPermission: (
    level: PermissionLevel,
    initiativeId?: number,
    featureId?: number,
    type?: LayoutType | 'any'
  ) => boolean
  hasAnyInitiativeOrBelowPermission: (level: PermissionLevel) => boolean
  someRole: (roles: Role[]) => boolean
}

export class InitiativePermission {
  level: PermissionLevel
  initiativeId?: number
  featureId?: number
  type?: LayoutType | 'any'

  constructor(
    level: PermissionLevel,
    initiativeId?: number,
    featureId?: number,
    type?: LayoutType | 'any'
  ) {
    this.level = level
    this.initiativeId = initiativeId
    this.featureId = featureId
    this.type = type
  }
}

export class AnyInitiativeOrBelowPermission {
  level: PermissionLevel

  constructor(level: PermissionLevel) {
    this.level = level
  }
}

export class AdminPermission {
  type: AdminPermissionType
  level: PermissionAdminLevel

  constructor(type: AdminPermissionType, level: PermissionAdminLevel) {
    this.type = type
    this.level = level
  }
}

export type Role =
  | AdminPermission
  | InitiativePermission
  | AnyInitiativeOrBelowPermission
